/** The one lesson a guest may open (guest-mode spec §4). */
export const GUEST_LESSON = 1
/** Where a guest lands when a page is not theirs to see. */
export const GUEST_SIGNIN_HREF = '/signin?guest=1'
